import React, { useState } from "react";
import { connect } from "react-redux";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button'
import withStyles from "@material-ui/core/styles/withStyles";
import * as actions from '../User/store/userActions';
import { parseURL } from '../../sc-utilities';
import { Redirect } from "react-router-dom";


const styles = theme => ({
    main: {
        width: "auto",
        display: "block", // Fix IE 11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(6))]: {
            width: 400,
            marginLeft: "auto",
            marginRight: "auto"
        }
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: '180px',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
    },
    logo: {
        width: "250px",
        margin: "10px"
    },
    submit: {
        marginTop: theme.spacing(2),
        width: "100%",
        color: theme.palette.buttonText.default,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
});

function isValidMail(email) {
    const regex = /\S+@\S+\.\S+/;
    return regex.test(email);
}

const Unsubscribe = props => {
    const { classes, onUnsubscribe } = props;
    const [emailState, setEmailState] = useState({ email: '', valid: false });

    const emailHandler = (event) => {
        setEmailState({ email: event.target.value, valid: isValidMail(event.target.value) });
    };

    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, redirectPath: '' });

    const redirectHandler = path => {
        setRedirectOptions({ redirect: true, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    let searchParams = parseURL(window.location.search);

    const handleSubmit = async () => {
        let response = await onUnsubscribe({ Email: emailState.email, MailID: searchParams.MailID, Type: searchParams.Type });
        if (response) {
            redirectHandler('/login');
            window.location.reload();
        }
    }

    return (
        <main className={classes.main}>
            <CssBaseline />
            <Paper className={classes.paper}>
                <img
                    alt="App logo"
                    className={classes.logo}
                    src={props.logoPath ? process.env.PUBLIC_URL + props.logoPath : process.env.PUBLIC_URL + "/assets/images/app-logo.svg"}
                />
                <Typography>Enter your email to confirm Your rescinding:</Typography>
                <TextField onChange={emailHandler} label="Email" fullWidth={true} error={!!emailState.email && !emailState.valid} onKeyPress={event => event.key === 'Enter' && emailState.valid ? handleSubmit() : null} />
                <Button
                    className={classes.submit}
                    variant="contained"
                    color="primary"
                    type="submit"
                    fullWidth={true}
                    disabled={!emailState.valid}
                    onClick={handleSubmit}>Unsubscribe</Button>
            </Paper>
        </main>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        onUnsubscribe: mail => dispatch(actions.initUnsubscribe(mail)),
    };
};

export default connect(null, mapDispatchToProps)(withStyles(styles, { withTheme: true })(Unsubscribe));
